var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSend(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "currentColor",
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.59 21.75c1.12 0 1.83-.38 2.28-.83.88-.88 1.5-2.75-.48-6.72l-.87-1.73c-.11-.23-.11-.71 0-.94l.87-1.73c1.99-3.97 1.36-5.85.48-6.72-.87-.88-2.75-1.51-6.71.48L5.6 7.84C3.47 8.9 2.3 10.38 2.3 12s1.17 3.1 3.29 4.16l8.56 4.28c1.94.97 3.38 1.31 4.44 1.31Zm0-18c.54 0 .96.13 1.22.39.73.72.44 2.59-.76 4.98l-.87 1.74c-.32.65-.32 1.63 0 2.28l.87 1.73c1.2 2.4 1.49 4.26.76 4.98-.72.73-2.59.44-4.99-.76l-8.56-4.28C4.69 14.03 3.8 13 3.8 11.99c0-1.01.9-2.04 2.47-2.82l8.56-4.27c1.52-.76 2.83-1.15 3.76-1.15Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M13.16 12.75h5.4c.41 0 .75-.34.75-.75s-.34-.75-.75-.75h-5.4c-.41 0-.75.34-.75.75s.34.75.75.75Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSend);
export default __webpack_public_path__ + "static/media/send.e0f0e4b4ada505f6b2b4d865ccc2a812.svg";
export { ForwardRef as ReactComponent };